module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Payment Requests",
      "name": "first"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Status",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.getPaymentRequest()
      }
    },
    model: {
      value: (_vm.filters.paymentStatus),
      callback: function($$v) {
        _vm.$set(_vm.filters, "paymentStatus", $$v)
      },
      expression: "filters.paymentStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Pending",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Confirmed",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Canceled",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Archived",
      "value": "3"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Rejected",
      "value": "4"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportNursePayment', 'payment.xls')
      }
    }
  }, [_vm._v("Export")])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showAddPayment
    }
  }, [_vm._v("Request a payment")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.firstListLoading),
      expression: "firstListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.payments,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "paymentNo",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "doctorName",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "amount",
      "label": "Amount"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.formatMoney(scope.row.amount, 2)) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "doctorNote",
      "label": "Doctor Note"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.doctorNote)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nurseNote",
      "label": "Nurse Note"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.nurseNote)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Request Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 0) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("Pending")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 1) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Confirmed")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 2) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("Canceled")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 4) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("Rejected")])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 0) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.editPaymentStatus(scope.row.paymentNo, 2)
            }
          }
        }, [_vm._v("Cancel\n                            ")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.paymentTotal
    },
    on: {
      "current-change": _vm.changePaymentRequest
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Pending Transactions",
      "name": "second"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Offer",
      "clearable": ""
    },
    model: {
      value: (_vm.filters.pendingFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "pendingFilter", $$v)
      },
      expression: "filters.pendingFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getPendingTransaction
    },
    slot: "append"
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.secondListLoading),
      expression: "secondListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.pendingPayments,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "offerNo",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Offer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouse",
      "label": "Warehouse"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "takeDate",
      "label": "Offer Create Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundDate",
      "label": "Inbound Date"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.pendingTotal
    },
    on: {
      "current-change": _vm.changePendingRequest
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Transaction History",
      "name": "third"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Search Product Name, Note, Account etc.",
      "clearable": ""
    },
    model: {
      value: (_vm.filters.historyFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "historyFilter", $$v)
      },
      expression: "filters.historyFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getTransactionHistory
    },
    slot: "append"
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.thirdListLoading),
      expression: "thirdListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.transactions,
      "highlight-current-row": "",
      "row-class-name": _vm.tableRowClassName
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Transaction"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type == 'transaction') ? _c('div', [_c('p', [_vm._v("For " + _vm._s(scope.row.productName) + ", " + _vm._s(scope.row.dateTime))]), _vm._v(" "), _c('p', {
          staticClass: "note"
        }, [_vm._v("$" + _vm._s(scope.row.price) + " * " + _vm._s(scope.row.quantity) + ".\n                                    " + _vm._s(scope.row.warehouse))])]) : _vm._e(), _vm._v(" "), (scope.row.type == 'reported') ? _c('div', [_c('p', [_vm._v("Reported for " + _vm._s(scope.row.productName) + ", " + _vm._s(scope.row.dateTime))]), _vm._v(" "), _c('p', {
          staticClass: "note"
        }, [_vm._v("$" + _vm._s(scope.row.price) + " * " + _vm._s(scope.row.quantity) + ".\n                                    " + _vm._s(scope.row.warehouse))])]) : _vm._e(), _vm._v(" "), (scope.row.type == 'adjust') ? _c('div', [(scope.row.amount > 0) ? _c('p', [_vm._v("Increase Balance, " + _vm._s(scope.row.dateTime))]) : _vm._e(), _vm._v(" "), (scope.row.amount <= 0) ? _c('p', [_vm._v("Decrease Balance, " + _vm._s(scope.row.dateTime))]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "note",
          domProps: {
            "innerHTML": _vm._s(scope.row.note)
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.type == 'payment') ? _c('div', [_c('p', [_vm._v("Withdraw to " + _vm._s(scope.row.productName) + ", " + _vm._s(scope.row.dateTime) + "\n                                    "), (scope.row.status === 0) ? _c('span', [_vm._v("(waiting for pay)")]) : (scope.row.status === 1) ? _c('span', [_vm._v("(paid)")]) : (scope.row.status === 2) ? _c('span', [_vm._v("(canceled)")]) : (scope.row.status === 3) ? _c('span', [_vm._v("(rollover)")]) : _vm._e()]), _vm._v(" "), _c('div', {
          staticClass: "note",
          domProps: {
            "innerHTML": _vm._s(scope.row.note)
          }
        })]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "amount",
      "label": "Amount"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.formatMoney(scope.row.amount, 2)) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Balance",
      "prop": "balance"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.historyTotal
    },
    on: {
      "current-change": _vm.changeTransactionHistory
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Balance",
      "name": "fourth"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fourthListLoading),
      expression: "fourthListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.balances,
      "highlight-current-row": "",
      "row-class-name": _vm.tableRowClassName
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "Company"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total",
      "label": "Total"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.formatMoney(scope.row.total, 2)) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pendingAmount",
      "label": "Pending"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.formatMoney(scope.row.pendingAmount, 2)) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "requestAmount",
      "label": "Request Pay"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.formatMoney(scope.row.requestAmount, 2)) + "\n                        ")]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.balanceTotal
    },
    on: {
      "current-change": _vm.changeBalance
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Request a payment",
      "width": "80%",
      "visible": _vm.requestVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.requestVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "payment",
    attrs: {
      "model": _vm.payment,
      "label-width": "220px",
      "rules": _vm.requestFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Total Balance",
      "prop": "balance"
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.payment.balance),
      callback: function($$v) {
        _vm.$set(_vm.payment, "balance", $$v)
      },
      expression: "payment.balance"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Amount",
      "prop": "amount"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "max": _vm.payment.balance
    },
    model: {
      value: (_vm.payment.amount),
      callback: function($$v) {
        _vm.$set(_vm.payment, "amount", $$v)
      },
      expression: "payment.amount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Bank Account",
      "prop": "bank"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.payment.bank),
      callback: function($$v) {
        _vm.$set(_vm.payment, "bank", $$v)
      },
      expression: "payment.bank"
    }
  }, _vm._l((_vm.banks), function(bank, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": bank.category + ' ' + bank.accountNumber + ' (' + bank.accountType + ')',
        "value": bank.bankNo
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.payment.note),
      callback: function($$v) {
        _vm.$set(_vm.payment, "note", $$v)
      },
      expression: "payment.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.requestVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.requestPayment.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13b660ba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nurse/payments.vue
// module id = 812
// module chunks = 1